import { useEffect } from "react";

export const useDeviceToken = () => {
  useEffect(() => {
    const saveDeviceToken = (rawToken, source) => {
      if (typeof rawToken !== "string") return;

      const token = rawToken.trim();
      if (!token) return;

      const isLikelyJSON = token.startsWith("{") || token.startsWith("[");
      const tooShort = token.length < 40; 
      const hasSpace = token.includes(" ");

      if (isLikelyJSON || tooShort || hasSpace) {
        console.log(
          "[DeviceToken] Ignored token from",
          source,
          "- failed basic validation:",
          token
        );
        return;
      }

      try {
        localStorage.setItem("deviceToken", token);
        console.log("[DeviceToken] Saved token from", source, ":", token);
      } catch (error) {
        console.error(
          "[DeviceToken] Failed to save token to localStorage:",
          error
        );
      }
    };

    try {
      const params = new URLSearchParams(window.location.search);
      const tokenFromUrl = params.get("deviceToken");

      if (tokenFromUrl) {
        saveDeviceToken(tokenFromUrl, "url");
      } else {
        console.log("[DeviceToken] No deviceToken query param in URL");
      }
    } catch (error) {
      console.error("[DeviceToken] Error reading deviceToken from URL:", error);
    }

    const handleMessage = (event) => {
      saveDeviceToken(event.data, "message");
    };

    window.addEventListener("message", handleMessage);
    console.log("[DeviceToken] window message listener attached");

    return () => {
      window.removeEventListener("message", handleMessage);
      console.log("[DeviceToken] window message listener removed");
    };
  }, []);
};
